import type { QueryClient } from '@tanstack/react-query'
import { queryOptions } from '@tanstack/react-query'

import { fetchMeasurementById } from '../dal/measurement-dal'
import { queryKeys } from './query-keys'

export type { MeasurementAnswerInput } from '../dal/measurement-dal'

export const measurementQueryOptions = (measurementId: number) =>
  queryOptions({
    queryKey: queryKeys.measurements.byId(measurementId),
    queryFn: () => fetchMeasurementById(measurementId),
    staleTime: 60 * 1000,
  })

export async function hasSavedMeasurementData(
  queryClient: QueryClient,
  measurementId: number | null | undefined,
) {
  if (measurementId == null) {
    return false
  }

  const measurement = await queryClient.ensureQueryData(
    measurementQueryOptions(measurementId),
  )

  return measurement.answers != null
}
